import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';

import {
  getTourOperatorDescription,
  type GetTourOperatorDescriptionParams,
  type TourOperatorDescriptionResult,
} from '@/api/bffSupport';

export const FETCH_OPERATOR_DESCRIPTION =
  'v1/tourOperator/FETCH_OPERATOR_DESCRIPTION';

export type FetchTourOperatorDescriptionSuccess =
  // @ts-expect-error ...
  ApiSuccess<TourOperatorDescriptionResult>;

export const fetchTourOperatorDescription = (
  params: GetTourOperatorDescriptionParams
): {types: Array<string>; callAPI: () => Promise<unknown>} => {
  return {
    types: ASYNC_TYPES(FETCH_OPERATOR_DESCRIPTION),
    callAPI: async () => {
      const response = await getTourOperatorDescription(params);
      if (response.status !== 200) {
        throw new Error(
          `Error fetching tour operator description: ${response.status}`
        );
      }
      return response.data;
    },
  };
};
